'use client';
import { useCallback, useState } from 'react';

const defaultOptions: globalThis.PositionOptions = {
  enableHighAccuracy: true,
  timeout: 10000, // 10 seconds
  maximumAge: 300000, // 5 minutes
};

export const useCurrentLocation = (options?: globalThis.PositionOptions) => {
  const [location, setLocation] = useState<google.maps.LatLngLiteral | null>(
    null
  );
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const getLocation = useCallback(() => {
    if (!navigator.geolocation) {
      setError('Geolocation not supported');
      return Promise.reject('Geolocation not supported');
    }

    setError(null);
    setLoading(true);

    return new Promise<google.maps.LatLngLiteral>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const newLocation = {
            lat: +pos.coords.latitude,
            lng: +pos.coords.longitude,
          };
          setLocation(newLocation);
          setLoading(false);
          resolve(newLocation);
        },
        (err) => {
          setError(err.message);
          setLoading(false);
          reject(err);
        },
        { ...defaultOptions, ...options }
      );
    });
  }, [options]);

  return { currentLocation: location, error, loading, getLocation };
};
